import {
    Card,
    CardActions,
    CardContent,
    Divider,
    Stack,
    Typography
} from "@mui/material";
import ArrowDownwardRoundedIcon from '@mui/icons-material/ArrowDownwardRounded';
import Box from "@mui/material/Box";
import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';
import SwapTokenCard from "../../components/Swap/SwapTokenCard";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


export default function Swap() {


    return <Card sx={{maxWidth: 600, margin: "0 auto"}}>
        <CardContent>
            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                Swap
            </Typography>
            <Box sx={{width: '100%'}}>
                <Stack spacing={2}>
                    <Item>
                        <SwapTokenCard/>
                    </Item>
                    <Divider><ArrowDownwardRoundedIcon/></Divider>
                    <Item>    <SwapTokenCard/> </Item>
                </Stack>
            </Box>
        </CardContent>
        <CardActions>

        </CardActions>
    </Card>
}